import { DateLike } from '@topconagriculture/language';

export interface LoadDataItem {
  id: string;
  ingredientId: string;
  callWeight: number;
  actualWeight: number;
  headCount: number;
  driverId: string;
  dryMatterPerc: number;
  loadStartTime: string;
  loadTime: Date;
  resized: boolean;
  startingPreset: number;
  callWeightChange: number;
}

export interface DeliveryDataItem {
  id: string;
  groupId: string;
  callWeight: number;
  actualWeight: number;
  headCount: number;
  driverId: string;
  dryMatterPerc: number;
  deliveryTime: Date;
  refusalWeight: number;
  refusalPerc: number;
}

export interface LoadDeliveryData {
  id: string;
  loads: LoadDataItem[];
  deliveries: DeliveryDataItem[];
  startDateTime: Date;
  endDateTime: Date;
  rationId: string;
  numberOfLoads: number;
  numberOfDeliveries: number;
}

export interface BatchedLoadDeliveryData {
  batchDate: Date;
  data: LoadDeliveryData[];
}

export interface DateRangeDefined {
  startDate: Date;
  endDate: Date;
}

export interface PriceItem {
  id: string;
  timeStamp: Date | string;
  price: number;
  readOnly: boolean;
}

export interface IngredientPrices {
  ingredientId: string;
  prices: PriceItem[];
}

export interface Milking {
  id: string;
  groupId: string;
  date: DateLike;
  amount: number;
  headCount: number;
  proteinPerc: number;
  fatPerc: number;
}

export interface Concentrate {
  id: string;
  groupId: string;
  date: DateLike;
  amount: number;
  headCount: number;
  price: number;
}

export interface MilkPrice {
  id: string;
  description: string;
  groupId: string;
  groupsMode: string;
  includeNotInUse: boolean;
  includeDeleted: boolean;
  date: Date;
  price: number;
}

export enum GroupMode {
  MILKING = 'milking',
  ALL = 'all',
}

export enum groupTypeFilters {
  CURRENT_PEN_ONLY = 'currentPenOnly',
  MILKING = 'milking',
  ALL_PENS = 'allPens',
  INCLUDE_NOT_IN_USE = 'includeNotinUse',
  INCLUDE_DELETED = 'includeDeleted',
}
